import { render, staticRenderFns } from "./ConsultantStat.vue?vue&type=template&id=da74c248&scoped=true&lang=pug&"
import script from "./ConsultantStat.vue?vue&type=script&lang=coffee&"
export * from "./ConsultantStat.vue?vue&type=script&lang=coffee&"
import style0 from "./ConsultantStat.vue?vue&type=style&index=0&id=da74c248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da74c248",
  null
  
)

component.options.__file = "ConsultantStat.vue"
export default component.exports